import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IAuctionCategories } from '../interface';
@Component({
    selector: 'app-storagetreasure',
    templateUrl: './storagetreasure.component.html',
    styleUrls: ['./storagetreasure.component.scss'],
    standalone: false
})

export class StoragetreasureComponent implements OnInit {
  @Input() auctionCategories: IAuctionCategories[] = [];
  @Input() previewImages: string[] = [];
  @Input() publishAdvertisement: boolean;
  @Input() unitContents: string = '';
  @Input() isPrintModule:boolean;
  @Output() unitContentsChange = new EventEmitter<string>();
  @Output() imageRemove = new EventEmitter<number>();
  @Output() imagesSelected = new EventEmitter<File[]>();
  @Output() selectedCategoryIdsChange = new EventEmitter<any[]>();
  @Output() publishAdvertisementChange = new EventEmitter<boolean>();
  selectedCategoryIds: any[] = [];
  allSelected = false;
  unitContentsTouched :boolean= false;
  unitContentsError : boolean = false;
  imageSizeExceeded: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  onFileSelected(event: any) {
    const files: File[] = Array.from(event.target.files);
    const maxSize = 10 * 1024 * 1024;
    const validFiles = files.filter(file => file.size <= maxSize);
    if (validFiles.length !== files.length) {
     this.imageSizeExceeded = true;
    } else {
    this.imageSizeExceeded = false;
    this.imagesSelected.emit(validFiles);
    } 
    event.target.value = null;
  }


  removeImage(index: number) {
    this.imageRemove.emit(index);
  }

  isCategorySelected(category: any): boolean {
    return this.selectedCategoryIds.includes(category.CategoryId);
  }


  selectAuctionCategories(category: any, event: any) {
    if (event.target.checked) {
      this.selectedCategoryIds.push(category.CategoryId);
    } else {
      this.selectedCategoryIds = this.selectedCategoryIds.filter(CategoryId => CategoryId !== category.CategoryId);
    }
    this.allSelected = this.selectedCategoryIds.length === this.auctionCategories.length;

    this.emitSelection();
  }


  selectAllAuctionCategories(event: any) {
    if (event.target.checked) {
      this.selectedCategoryIds = this.auctionCategories.map(c => c.CategoryId);
      this.allSelected = true;
    } else {
      this.selectedCategoryIds = [];
      this.allSelected = false;
    }

    this.emitSelection();
  }

  emitSelection() {
    this.selectedCategoryIdsChange.emit([...this.selectedCategoryIds]);
  }

onPublishAdvertisementChange(event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  this.publishAdvertisement = checked;
  this.publishAdvertisementChange.emit(checked);
}

onUnitContentsChange(event: Event) {
  const value = (event.target as HTMLTextAreaElement).value;
  this.unitContentsTouched = true;
   this.unitContentsError = !value.trim();
  this.unitContentsChange.emit(value);
}
}
